<template>
  <div>
    <Breadcrumbs main="Inventario" title="Ingresos"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'InventoryInvoiceForm'}">
                  <i class="fa fa-map-marker"></i> Agregar ingreso
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                        ref="table"
                        :fields="datatableConfig.fields"
                        :opts="datatableConfig.options"
                        @editObject="editObject"
                        @displayDispatch="displayDispatch"
                >
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import $ from 'jquery';
  window.jQuery = $;
  import VdtnetTable from 'vue-datatables-net';
  import 'datatables.net-bs4';
  import utils from '../../../utils';
  import axios from "axios";
  export default {
    components: {
      VdtnetTable
    },
    data(){
      return{
        datatableConfig : {
          options: {
            lengthMenu: [10, 25, 50],
            pageLength: 10,
            lengthChange: false,
            processing: true,
            serverSide: true,
            searchDelay: 500,
            fixedHeader: true,
            responsive: true,
            ajax: {
              url: axios.defaults.baseURL + '/api/inventory/v1.0/invoice/?format=datatables',
              type: "GET",
              headers: {
                Authorization: 'JWT ' + localStorage.getItem('token')
              },
              dataSrc: (json) => {
                return json['data'];
              }
            },
            language: {
              decimal: "",
              emptyTable: "No hay información",
              info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
              infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
              infoFiltered: "(Filtrado de _MAX_ total entradas)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ Entradas",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              zeroRecords: "Sin resultados encontrados",
              paginate: {
                first: "Primero",
                last: "Ultimo",
                next: "Siguiente",
                previous: "Anterior"
              }
            },
            "drawCallback": function () {
              // const num_row = $('.dataTables_length');
              $('div.vdtnet-container').removeClass('table-responsive');
              // num_row.find('select').removeClass('custom-select form-control');
              $('.dataTables_paginate').addClass('pull-right mt-2');
              $('.dataTables_info').addClass('mt-2');
            },
          },
          fields: {
            id: {
              data: 'id',
              visible: false,
              searchable: false,
            },
            image: {
              data: 'image',
              visible: false,
              searchable: false,
            },
            date_register: {
              name: 'date_register',
              label: 'Fecha de registro',
              data: 'date_register',
              sortable: true,
            },
            date: {
              name: 'date',
              label: 'Fecha de llegada',
              data: 'date',
              sortable: true,
            },
            code: {
              name: 'code',
              label: 'Código',
              data: 'code',
              sortable: true,
            },
            client: {
              name: 'client__business_name',
              label: 'Cliente',
              data: 'client.business_name'
            },
            actions: {
              label: 'Acciones',
              isLocal: true,
              render: function () {
                return '<a href="javascript:void(0);" data-action="editObject" title="Modificar"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a> ' +
                    '<a href="javascript:void(0);" data-action="displayDispatch" title="Visualizar guía"><span class="badge badge-danger"><i class="fa fa-file-pdf-o"></i></span></a>';
              }
            }
          },
          quickSearch: '',
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalTable);
    },
    mounted() {
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    methods: {
      reloadTable() {
        // ELIMINAOS EL INTERVALO
        clearInterval(this.intervalTable);
        // RECARGAMOS
        this.$refs.table.reload();
        // GENERAMOS EL INTERVALO
        this.intervalTable = setInterval(() => {
          this.$refs.table.reload();
        }, utils.timeRefresh * 1000);
      },
      doSearch() {
        this.$refs.table.search(this.datatableConfig.quickSearch);
      },
      editObject(data){
        this.$router.push({'name': 'InventoryInvoiceFormEdit', params: { objectId: data['id'] }});
      },
      displayDispatch(data){
        window.open(data['image'], '_blank');
      }
    },
  }
</script>

<style>
  table img {
    width: 100px;
    height: 100px;
  }
</style>